<template>
  <!-- O que JÁ está escolhido num campo de relacionamento, e SEM chip: a caixa do chip brigava com a
       régua — duas molduras para a mesma coisa. Texto com a régua ao lado é o mesmo desenho da célula
       da listagem e do valor na ficha.

       Sem o chip, o X de remover deixa de vir da biblioteca; ele volta aqui como botão discreto, e só
       quando quem usa diz que pode (`removable`). -->
  <span class="rel-selection">
    <ontos-color-accent vertical :color="optionColorOf(item)" class="rel-accent"/>
    <span class="rel-selection-text">{{ item._identifier || item.raw?._identifier }}</span>
    <ontos-remove-button v-if="removable" @click.stop.prevent="$emit('remove', item)"/>
  </span>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import ColorAccent from '@/components/shared/ColorAccent.vue'
import RemoveButton from '@/components/shared/RemoveButton.vue'
import {optionColorOf} from '@/utils/propertyDisplay'

/**
 * Um valor escolhido num campo de relacionamento: a régua da cor do item, o nome e o X.
 *
 * Para o slot `#selection` do autocomplete. Estava escrito igual, marcação e estilo, no campo de
 * relacionamento e no reverso, e a janela de vincular existentes desenhava o chip do Vuetify no lugar
 * — fora do padrão (relato do usuário). Agora os três desenham daqui.
 */
@Component({emits: ['remove'], name: 'ontos-rel-selection', components: {'ontos-color-accent': ColorAccent, 'ontos-remove-button': RemoveButton}})
class RelSelection extends Vue {
  /** O item como o slot entrega — cru ou embrulhado; ver o `optionColorOf`. */
  @Prop({required: true}) readonly item!: any
  @Prop({type: Boolean, default: false}) readonly removable!: boolean
  //exposta ao template: função de módulo não é enxergada de lá
  optionColorOf = optionColorOf
}

export default toNative(RelSelection)
</script>

<style scoped>
/* A régua ao lado de um nome: 3px, a mesma escala do valor na listagem e na ficha. Largura e
   altura por variável, nunca por classe que dispute a propriedade com o próprio componente. */
.rel-accent {
  --ontos-accent-width: 3px;
  margin-right: 6px;
}

/* Valores escolhidos numa linha só, respirando entre si — o papel que a borda do chip fazia. */
.rel-selection {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  margin: 2px 10px 2px 0;
}

.rel-selection-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
